/* eslint-disable react/jsx-no-duplicate-props */
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useState } from "react";


import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import AddAssistant from "../../../Modals/addAssistant";
import AddFeature from "../../../Modals/addfeature";
import AddProvider from "../../../Modals/addProvider";


const AiCapabilitiesPage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [module, setModule] = useState("Module");
  const [guardrailLevel, setGuardrailLevel] = useState("gaurd");

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => setOpenModal(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);


  const handleCloseModal1 = () => setOpenModal1(false);
  const handleCloseModal2 = () => setOpenModal2(false);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  /* ================= FEATURE LISTING ================= */
  const featureRows = [
    {
      id: 1,
      featureName: "Smart Pricing",
      description: "Suggests optimal price based on market trends.",
      module: "Pricing Engine",
      scope: "Limited Rollout",
      guardrailLevel: "Medium",
      rollout: "25%",
      updated: "Today",
      updatedBy: "Admin",
      status: "active",
    },
    {
      id: 2,
      featureName: "Auto Categorization",
      tag: "Testing",
      description: "Automatically assigns category to newly added products.",
      module: "Product Management",
      scope: "Admin / Vendor",
      guardrailLevel: "Low",
      rollout: "10%",
      updated: "Today",
      updatedBy: "Jane Doe",
      status: "active",
    },
    {
      id: 3,
      featureName: "Customer Segmentation",
      description: "Groups users based on buying behaviour.",
      module: "Analytics",
      scope: "Marketing / Elite Tier",
      guardrailLevel: "High",
      rollout: "50%",
      updated: "2 days ago",
      updatedBy: "Michael L.",
      status: "inactive",
    },
    {
      id: 4,
      featureName: "Dispute Resolution",
      description: "Suggests solutions for disputes automatically.",
      module: "Moderation",
      scope: "Admin / Grow Tier",
      guardrailLevel: "High",
      rollout: "0%",
      updated: "5 days ago",
      updatedBy: "Sarah M.",
      status: "inactive",
    },
  ];

  /* ================= ASSISTANTS LISTING ================= */
  const assistantRows = [
    {
      id: 1,
      name: "Vendor Support Agent",
      module: "Product Management",
      userType: "Vendor",
      provider: "ChatGPT",
      model: "GPT-4o",
      firstMessage: "Hello! How can I assist you today?",
      priority: "Medium",
    },
    {
      id: 2,
      name: "Admin Operation Assistant",
      module: "Admin Operations",
      userType: "Admin",
      provider: "Gemini",
      model: "Gemini 1.5 Pro",
      firstMessage: "Welcome, Admin. How can I assist with your operational tasks?",
      priority: "High",
    },
    {
      id: 3,
      name: "Customer Interaction Assistant",
      module: "Customer Support",
      userType: "Admin",
      provider: "Claude",
      model: "Claude 3 Opus",
      firstMessage: "Hi. Need help with customer inquires?",
      priority: "Low",
    },
  ];


  const providerRows = [
    {
      id: 1,
      providerName: "OpenAI",
      authStatus: "Connected",
      region: "Global",
      models: "GPT-4o, GPT-4 Turbo, GPT-3.5 Turbo",
      costProfile: "30% above Generate credit capacity",
      routing: "60%",
      riskLevel: "Medium",
    },
    {
      id: 2,
      providerName: "Google",
      authStatus: "Connected",
      region: "Global",
      models: "Gemini 1.5 Pro, Gemini 1.5 Flash, Gemini 1.0",
      costProfile: "On par with Generate credit capacity",
      routing: "20%",
      riskLevel: "Low",
    },
    {
      id: 3,
      providerName: "Anthropic",
      authStatus: "Connected",
      region: "Global",
      models: "Claude 3 Opus, Claude 3 Sonnet, Claude 2",
      costProfile: "15% below Generate credit capacity",
      routing: "20%",
      riskLevel: "High",
    },
    {
      id: 4,
      providerName: "OpenAI",
      authStatus: "Connected",
      region: "Global",
      models: "Claude 3 Opus, Claude 2",
      costProfile: "15% above Generate credit capacity",
      routing: "20%",
      riskLevel: "High",
    },
  ];


  return (
    <>
      {/* ================= PAGE TITLE ================= */}
      <div className="main_title ai_command_page d_flex">
        <div className="lt">
          <h1>AI Capabilities & Assistants</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Capabilities & Assistants
          </p>
        </div>

      </div>


      {/* ================= TABS ================= */}
      <Box className="custom_tabs1 mt_20">
        <Tabs value={tabIndex} onChange={handleTabChange} className="custom_tabs_links">
          <Tab label="AI Features " />
          <Tab label="AI Assistants" />
          <Tab label="AI Models & Providers" />

        </Tabs>
      </Box>

      {/* ================= FEATURE LISTING TAB ================= */}
      {tabIndex === 0 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s ">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Features..."
              />
              <div className="form">
                <div className="control_group">
                  <Select
                    value={module}
                    label="Module"
                    onChange={(e) => setModule(e.target.value)}
                  >
                    <MenuItem value="Module" disabled>
                      Select Module
                    </MenuItem>
                    <MenuItem value="Hiring">Hiring</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                    <MenuItem value="Marketing">Marketing</MenuItem>
                    <MenuItem value="Operations">Operations</MenuItem>
                  </Select>
                </div>

                <div className="control_group">
                  <Select
                    value={guardrailLevel}
                    onChange={(e) => setGuardrailLevel(e.target.value)}
                  >
                    <MenuItem value="gaurd" disabled>
                      Select Guardrail
                    </MenuItem>
                    <MenuItem value="low">Low</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="high">High</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <TableContainer className="table_container tag_design">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Feature Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Module</TableCell>
                  <TableCell>Scope</TableCell>
                  <TableCell>Guardrail Level</TableCell>
                  <TableCell>Rollout</TableCell>
                  <TableCell>Updated</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {featureRows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>

                    {/* Feature Name + tag */}
                    <TableCell>
                      <b>{row.featureName}</b>
                      {/* {row.tag && <span className="tag testing">{row.tag}</span>} */}
                    </TableCell>

                    <TableCell>{row.description}</TableCell>

                    <TableCell>{row.module}</TableCell>

                    <TableCell>
                      <span className="chip neutral">{row.scope}</span>
                    </TableCell>

                    <TableCell>
                      <span className={`chip ${row.guardrailLevel.toLowerCase()}`}>
                        {row.guardrailLevel}
                      </span>
                    </TableCell>

                    <TableCell>{row.rollout}</TableCell>

                    <TableCell>
                      <div className="updated">
                        <span>{row.updated}</span>
                        <small>{row.updatedBy}</small>
                      </div>
                    </TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal1(true)}> <EditOutlinedIcon />
                        </IconButton> <IconButton> <DeleteOutlineOutlinedIcon /> </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      {/* ================= ASSISTANTS TAB ================= */}
      {tabIndex === 1 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Assistants..."
              />
              <div className="form">

                {/* Module */}
                <div className="control_group">
                  <Select
                    value={module}
                    onChange={(e) => setModule(e.target.value)}
                  >
                    <MenuItem value="Module" disabled>
                      Select Module
                    </MenuItem>
                    <MenuItem value="Product Management">Product Management</MenuItem>
                    <MenuItem value="Hiring">Hiring</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                    <MenuItem value="Marketing">Marketing</MenuItem>
                    <MenuItem value="Operations">Operations</MenuItem>
                  </Select>
                </div>

                {/* User Type */}
                <div className="control_group">
                  <Select
                    defaultValue="user"
                    fullWidth hiddenLabel
                  >
                    <MenuItem value="user" disabled>
                      Select User Type
                    </MenuItem>
                    <MenuItem value="Vendor">Vendor</MenuItem>
                    <MenuItem value="Customer">Customer</MenuItem>
                    <MenuItem value="Admin">Admin</MenuItem>
                  </Select>
                </div>

                {/* Provider */}
                <div className="control_group">
                  <Select
                    defaultValue="provider"
                    fullWidth hiddenLabel
                  >
                    <MenuItem value="provider" disabled>
                      Select Provider
                    </MenuItem>
                    <MenuItem value="ChatGPT">ChatGPT</MenuItem>
                    <MenuItem value="Gemini">Gemini</MenuItem>
                    <MenuItem value="Claude">Claude</MenuItem>
                  </Select>
                </div>

              </div>
            </div>
            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
                <AddIcon /> Add Assistant
              </Button>
            </div>
          </div>

          <TableContainer className="table_container tag_design">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Assistant Name</TableCell>
                  <TableCell>Module</TableCell>
                  <TableCell>User Type</TableCell>
                  <TableCell>Provider</TableCell>
                  <TableCell>Model (Version)</TableCell>
                  <TableCell>First Message</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell></TableCell>

                </TableRow>
              </TableHead>

              <TableBody>
                {assistantRows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>

                    <TableCell><b>{row.name}</b></TableCell>
                    <TableCell>{row.module}</TableCell>
                    <TableCell>{row.userType}</TableCell>
                    <TableCell>{row.provider}</TableCell>
                    <TableCell>{row.model}</TableCell>
                    <TableCell>{row.firstMessage}</TableCell>

                    <TableCell>
                      {/* Priority Chip */}
                      <span className={`chip ${row.priority.toLowerCase()}`}>
                        {row.priority}
                      </span>
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal1(true)}> <EditOutlinedIcon />
                        </IconButton> <IconButton> <DeleteOutlineOutlinedIcon /> </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      {tabIndex === 2 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Assistants..."
              />
            </div>
          </div>


          <TableContainer className="table_container tag_design">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Provider Name</TableCell>
                  <TableCell>Auth Status</TableCell>
                  <TableCell>Region</TableCell>
                  <TableCell>Models Supported</TableCell>
                  <TableCell>Cost Profile</TableCell>
                  <TableCell>Routing %</TableCell>
                  <TableCell>Risk Level</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {providerRows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>

                    <TableCell><b>{row.providerName}</b></TableCell>

                    <TableCell>
                      <span className="status_chip connected">
                        {row.authStatus}
                      </span>
                    </TableCell>

                    <TableCell>{row.region}</TableCell>
                    <TableCell>{row.models}</TableCell>
                    <TableCell>{row.costProfile}</TableCell>
                    <TableCell>
                      <span
                        className="tag"
                        style={{
                          background:
                            parseInt(row.routing) >= 50 ? "#e0e7ff" : "#f1f5f9",
                          color:
                            parseInt(row.routing) >= 50 ? "#3730a3" : "#475569",
                        }}
                      >
                        {row.routing}
                      </span></TableCell>

                    <TableCell>
                      <span className={`chip ${row.riskLevel.toLowerCase()}`}>
                        {row.riskLevel}
                      </span>
                    </TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal2(true)}>
                          <EditOutlinedIcon />
                        </IconButton>
                        <IconButton>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>



        </div>
      )}

      {/* ================= MODAL ================= */}
      <AddAssistant open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
      <AddFeature open={openModal1} onClose={handleCloseModal1} setOpen={setOpenModal1} />
      <AddProvider open={openModal2} onClose={handleCloseModal2} setOpen={setOpenModal2} />

    </>
  );
};

export default AiCapabilitiesPage;
